export const VIDEO_INFORMATION = 'VIDEO_INFORMATION'
export const RESPONSE_STATUS = 'RESPONSE_STATUS'
export const CLEAR_RESPONSE = 'CLEAR_RESPONSE'
